export const Group = {
  "background-color": "color",
  direction: "enum(ltr,rtl)",
  "vertical-align": "enum(top,bottom,middle)",
  width: "unit(px,%)",
};
